import { formatSecondsToMinutes } from "commons/utils/function";
import { PropertyStatus } from "constraints/PropertyEnum";
import { Check } from 'lucide-react';
import { useTranslation } from "react-i18next";

const FormType = {
    START: 'start',
    ERROR: 'error',
    DISCONNECT: 'disconnect',
    LOADING: 'loading'
};

const SplashScreen = ({
    project,
    getErrorMessage,
    isDisconnected,
    countdown,
    handleStartChoose,
    handleConfirmDisconnect,
    isFetching
}) => {

    const { t } = useTranslation();

    const determineFormType = (project, getErrorMessage, isDisconnected, isFetching) => {
        if (isFetching) {
            return FormType.LOADING;
        }

        if (isDisconnected) {
            return FormType.DISCONNECT;
        }

        if (getErrorMessage || project?.status === PropertyStatus.SELECTED) {
            return FormType.ERROR;
        }

        return FormType.START;
    };

    const formType = determineFormType(project, getErrorMessage, isDisconnected, isFetching);

    const renderFormContent = () => {
        switch (formType) {
            case FormType.START:
                return renderStartForm();
            case FormType.ERROR:
                return renderErrorForm();
            case FormType.DISCONNECT:
                return renderDisconnectForm();
            case FormType.LOADING:
                return renderLoadingForm();
            default:
                return renderStartForm();
        }
    };

    const renderStartForm = () => {
        return (
            <div className="start-section">
                <div className="welcome-message">
                    <p>{t('cart.ready_prompt')}</p>
                    <p>{t('cart.time_left')} <strong>{formatSecondsToMinutes(countdown)} {t('cart.minutes')}</strong></p>
                </div>
                <button
                    className="start-button"
                    onClick={handleStartChoose}
                >
                    🚀 {t('cart.start_select')}
                </button>
            </div>
        );
    };

    // Form lỗi/đã chọn
    const renderErrorForm = () => {
        return (
            <div className="error-section">
                <div className="error-icon">
                    {project?.status === PropertyStatus.SELECTED ?
                        <Check color="#56d08a" size={120} /> :
                        "⚠️"
                    }
                </div>
                <div className="error-message">
                    {project?.status === PropertyStatus.SELECTED ?
                        t('cart.selected_already') :
                        getErrorMessage
                    }
                </div>
                {project?.status === PropertyStatus.SELECTED && (
                    <div className="booking-info">
                        <div className="booking-info-item">
                            <strong>{t('cart.booking_code')} </strong>{project.bookingCustomId}
                        </div>
                        <div className="booking-info-item">
                            <strong>{t('cart.spot_code')} </strong>{project.propertyNo}
                        </div>
                    </div>
                )}
            </div>
        );
    };

    // Form xác nhận ngắt kết nối
    const renderDisconnectForm = () => {
        return (
            <div className="disconnect-section">
                <div className="disconnect-icon">
                    🔌
                </div>
                <div className="disconnect-message">
                    <h3>{t('cart.disconnect_title')}</h3>
                    <p>{t('cart.disconnect_message')}</p>
                    <p className="disconnect-warning">
                        {t('cart.disconnect_warning')}
                    </p>
                </div>
                <div className="disconnect-actions">
                    <div
                        className="disconnect-confirm-button"
                        onClick={() => handleConfirmDisconnect()}
                    >
                        {t('cart.confirm_disconnect')}
                    </div>
                </div>
            </div>
        );
    };

    // Form loading
    const renderLoadingForm = () => {
        return (
            <div className="loading-section">
                <div className="loading-spinner">
                    <div className="spinner"></div>
                </div>
                <div className="loading-message mt-4">
                    <h3>{t('cart.loading_title')}</h3>
                    <p>{t('cart.loading_message')}</p>
                </div>
            </div>
        );
    };

    const shouldShowLegend = formType === FormType.START;

    return (
        <div className="splash-screen">
            <div className="splash-content">
                <div className="splash-header">
                    <h1 className="splash-title">{t('cart.title')}</h1>
                    {project?.projectName && (
                        <div className="project-info">
                            <strong>{t('cart.project')} </strong>{project.projectName}
                        </div>
                    )}
                </div>

                <div className="splash-body">
                    {renderFormContent()}
                </div>

                {shouldShowLegend && (
                    <div className="splash-footer">
                        <div className="legend">
                            {/* <div className="legend-item">
                                <span className="legend-color not-for-sale"></span>
                                <span>{t('cart.not_for_sale')}</span>
                            </div> */}
                            <div className="legend-item">
                                <span className="legend-color available"></span>
                                <span>{t('cart.available')}</span>
                            </div>
                            <div className="legend-item">
                                <span className="legend-color sold"></span>
                                <span>{t('cart.sold')}</span>
                            </div>
                        </div>
                    </div>
                )}
            </div>
        </div>
    );
};

export default SplashScreen;